var wellKnownSymbol = require('../internals/well-known-symbol');

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';



//////////////////
// WEBPACK FOOTER
// /root/urbanmassage/node_modules/core-js-pure/internals/to-string-tag-support.js
// module id = 377
// module chunks = 44